module.exports = __webpack_public_path__ + "img/partner_magyartelekom.5149ceef.png";